const API_BASE = (process.env.REACT_APP_API_URL || 'https://api.royalpetstore.store/api').replace(/\/api\/?$/, '');

export function getImageUrl(path: string | null | undefined): string {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('data:') || path.startsWith('blob:')) return path;
  if (path.startsWith('/Exo35 Woollen shoes/')) return path;
  // New direct storage path (public/uploads/) – no symlink needed, works on cPanel
  if (path.startsWith('uploads/')) return `${API_BASE}/${path}`;
  // Legacy storage path (storage/app/public via symlink)
  return `${API_BASE}/storage/${path}`;
}
